import React, { useState } from "react";
import "./Contact.css";
import { db } from "../firebase"; // ✅ adjust the path if needed
import { collection, addDoc, Timestamp } from "firebase/firestore";

const ContactPage = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "contacts"), {
        ...formData,
        createdAt: Timestamp.now(),
      });
      alert("Message sent and saved successfully!");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Error saving contact:", error);
      alert("Failed to send message. Try again later.");
    }
  };

  return (
    <div className="contact-container">
      <h2>Contact Us</h2>

      <div className="contact-content">
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            required
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            required
            onChange={handleChange}
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            required
            onChange={handleChange}
          ></textarea>
          <button type="submit">Send Message</button>
        </form>

        <div className="contact-info">
          <h3>Reach Out</h3>
          <p><strong>Email:</strong> navveerfoundation@gmail.com</p>
          <p><strong>Phone:</strong> +91 9266101536</p>
          <a
            href="https://wa.me/919266101536"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-button"
          >
            Chat on WhatsApp
          </a>

          <h3>Our Location</h3>
          <p>Navveer Foundation, Sector 21, New Delhi, India</p>
          <div className="map-container">
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14014.973188175836!2d77.2174216!3d28.6139391!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd9b4a2fc1ff%3A0xf9682a19f06c5b76!2sNew%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1718532000000"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
